module.exports = __webpack_public_path__ + "static/media/facebook.6675d650.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/facebook.svg
// module id = 838
// module chunks = 0